import  merchantReducer from './merchant';
import signupReducer from './signup';
import userReducer from './userDuck';
import licenseEditReducer from './licenseEditDuck';
import appReducer from './appDuck';
import domainReducer from './domain';
import merchantEditReducer from './merchantEditDuck';

export default {
    merchant: merchantReducer,
    signup: signupReducer,
    user: userReducer,
    licenseEdit: licenseEditReducer,
    app: appReducer,
    domain: domainReducer,
    merchantEdit: merchantEditReducer,
};